import { Empty } from 'antd'

interface EmptyStateProps {
  description?: string
}

export function EmptyState({ description = 'No data' }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px'
    }}>
      <Empty description={description} />
    </div>
  )
}
